import { JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { FormlyField } from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'repeat-section',
    template: `
    <div class="mb-3">
        @for(field of field.fieldGroup; let i = $index; track field) {
            <div  class="flex flex-row gap-2 items-center">
                <formly-field class="grow" [field]="field"></formly-field>
                <div class="d-flex align-items-center">
                    <button pButton [outlined]="true" (click)="remove(i)"><i class="fa-solid fa-xmark"></i></button>
                </div>
            </div>
        }
        <a pButton [outlined]="true" (click)="add()"><i class="fa-solid fa-plus"></i></a>
    </div>
    `,
    imports: [FormlyField, ButtonModule],
})
export class RepeatTypeComponent extends FieldArrayType {}
